// Returns time to read in minutes
export const readingTime = (text: string, wpm = 225) => {
  return Math.ceil(text.trim().split(/\s+/).length / wpm);
};
